<template>
  <div class="row">
    <div class="col-md-6">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <img :src="product.bild_url" alt="Produktbild" style="width: 165px; height: auto;">
      </a>
    </div>
    <div class="col-md-6 d-flex flex-column align-items-center justify-content-center">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <button class="btn13 px-1 py-1">Auf Amazon ansehen*</button>
      </a>
    </div>
  </div>
  <div class="tt-product-tabs tt mt-2">
    <input :id="tabId('tt-tab1')" type="radio" :name="tabsName" checked="checked" />
    <input :id="tabId('tt-tab2')" type="radio" :name="tabsName" />
    <input :id="tabId('tt-tab3')" type="radio" :name="tabsName" />
    <input :id="tabId('tt-tab4')" type="radio" :name="tabsName" />

    <ul class="tt-tabs">
      <li class="tt-tab"><label :for="tabId('tt-tab1')">Display-Eigenschaften</label></li>
      <li class="tt-tab"><label :for="tabId('tt-tab2')">Ergonomie & Maße</label></li>
      <li class="tt-tab"><label :for="tabId('tt-tab3')">Fernseher-Funktionen</label></li>
    </ul>

    <div class="tt-tab-content">
      <div class="tt-display-properties">
        <div class="tt-property">
          <label>Diagonale (in Zoll)</label>
          <span v-if="!product.diagonale || isNaN(Number(product.diagonale))">
            Keine Information
          </span>
          <span v-else>{{ product.diagonale }}</span>
        </div>
        <div class="tt-property">
          <label>Auflösung</label>
          <span v-if="!product.horizontalpixel || isNaN(Number(product.vertikalpixel))">
            Keine Information
          </span>
          <span v-else>{{ product.horizontalpixel }} x {{ product.vertikalpixel }}</span>
        </div>
        <div class="tt-property">
          <label>Display</label>
          <span v-if="product.paneltech === null || product.paneltech === undefined || product.paneltech === ''">Keine Information</span>
          <span v-else>{{ product.paneltech }}</span>
        </div>
        <div class="tt-property">
          <label>Frequenz</label>
          <span v-if="product.frequenzvertikal_merged === '0.00' || product.frequenzvertikal_merged === 0 || product.frequenzvertikal_merged == null || isNaN(Number(product.frequenzvertikal_merged))">
            Keine Information
          </span>
          <span v-else>{{ product.frequenzvertikal_merged }} Hz</span>
        </div>
        <div class="tt-property">
          <label>Helligkeit (cd/m²)</label>
          <span v-if="product.helligkeit === '0' || product.helligkeit === 0 || product.helligkeit == null || isNaN(Number(product.helligkeit))">
            Keine Information
          </span>
          <span v-else>{{ product.helligkeit }}</span>
        </div>
        <div class="tt-property">
          <label>Maximale Helligkeit (cd/m²)</label>
          <span v-if="product.spitzenhelligkeit_merged === '0' || product.spitzenhelligkeit_merged === 0 || product.spitzenhelligkeit_merged == null || isNaN(Number(product.spitzenhelligkeit_merged))">
            Keine Information
          </span>
          <span v-else>{{ product.spitzenhelligkeit_merged }}</span>
        </div>
        <div class="tt-property">
          <label>Farbtiefe</label>
          <span v-if="!product.farbtiefebit || isNaN(Number(product.farbtiefebit))">
            Keine Information
          </span>
          <span v-else>{{ product.farbtiefebit }} Bit</span>
        </div>
        <div class="tt-property">
          <label>Reaktionszeit</label>
          <span v-if="product.reaktionszeit_merged === '0.00'">Keine Information</span>
          <span v-else>{{ product.reaktionszeit_merged }}ms</span>
        </div>
      </div>
    </div>

    <div class="tt-tab-content">
      <div class="tt-display-properties">
        <div class="tt-property">
          <label>Lautsprecher</label>
          <span v-if="product.anz_lautsprecher >= '1'">Ja, {{ product.lautsprecher_leistung }}</span>
          <span v-else>Keine Information</span>
        </div>
        <div class="tt-property">
          <label>Subwoofer</label>
          <span v-if="product.issubwoofer === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>
        <div class="tt-property">
          <label>Energieeffizienzklasse</label>
            <span>{{ product.energieeffizienzklasse_sdr }}</span>
        </div>
        <div class="tt-property">
          <label>Stromverbrauch</label>
          <span v-if="!product.stromverbrauchdurchschnitt || isNaN(Number(product.stromverbrauchdurchschnitt))">
            Keine Information
          </span>
          <span v-else>~{{ product.stromverbrauchdurchschnitt }} Watt</span>
        </div>
        <div class="tt-property">
          <label>Vesa-Wandhalterung</label>
          <span v-if="product.isvesa === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>
        <div class="tt-property">
          <label>Vesa-Maße</label>
          <span v-if="!product.vesax || isNaN(Number(product.vesax))">
            Keine Information
          </span>
          <span v-else>{{ product.vesax }} x {{ product.vesay }}</span>
        </div>
      </div>
    </div>

    <div class="tt-tab-content">
      <div class="tt-display-properties">
        <div class="tt-property">
          <div v-if="hdmiCount > 0">
            <label>HDMI</label>
            <span style="white-space: pre;">{{ hdmiString }}</span>
          </div>
        </div>
        <div class="tt-property">
          <div v-if="hasHDR">
            <label>HDR</label>
            <span>{{ hdrString }}</span>
          </div>
        </div>
        <div class="tt-property">
          <label>FreeSync</label>
          <span v-if="product.freesync === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>
        
        <div class="tt-property">
          <label>Betriebssystem</label>
            <span>{{ product.betriebssystem }}</span>
        </div>
        <div class="tt-property">
          <label>Technologie</label>
            <span>{{ product.technologie }}</span>
        </div>
        <div class="tt-property">
          <label>Gamemode</label>
          <span v-if="product.gamemode === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>
        <div class="tt-property">
          <label>YouTube</label>
          <span v-if="product.youtube === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="tt-property">
          <label>Netflix</label>
          <span v-if="product.netflix === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="tt-property">
          <label>Disney+</label>
          <span v-if="product.disneyplus === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="tt-property">
          <label>AirPlay</label>
          <span v-if="product.airplay === '1' || product.airplay2 === '1'">Ja</span>
          <span v-else>Nein</span>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import StarRating from "./StarRating.vue";

export default {
  components: {
    StarRating
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    instanceId: {
      type: String,
      default: "",
    },
  },

  computed: {
    safeInstanceId() {
      const rawId =
        this.instanceId ||
        this.product?.id ||
        this.product?.asin ||
        this.product?.amazon_url ||
        this.product?.amazonNamenSuche ||
        `fallback-${Math.random().toString(36).slice(2)}`;

      return String(rawId).replace(/[^A-Za-z0-9_-]/g, "-");
    },

    tabsName() {
      return `tabs-${this.safeInstanceId}`;
    },


    hdmiCount() {
      return Object.values(this.product).reduce((total, value) => total + (value > 0 ? 1 : 0), 0);
    },
    hdmiString() {
      let hdmiList = [];
      if (this.product.hdmi_1_4 > 0) hdmiList.push(`${this.product.hdmi_1_4} x HDMI 1.4`);
      if (this.product.hdmi_2_0 > 0) hdmiList.push(`${this.product.hdmi_2_0} x HDMI 2.0`);
      if (this.product.hdmi_2_1 > 0) hdmiList.push(`${this.product.hdmi_2_1} x HDMI 2.1`);
      return hdmiList.join('\n');
    },

    usbCount() {
      return Object.values(this.product).reduce((total, value) => total + (value > 0 ? 1 : 0), 0);
    },
    usbString() {
      const usbVersions = {
        usb_2_0: "USB 2.0",
        usb_3_0: "USB 3.0"
      };
      const activeUSBVersions = Object.keys(usbVersions).filter(key => this.product[key] > 0);
      return activeUSBVersions.length > 0 ? activeUSBVersions.map(version => `${this.product[version]} x ${usbVersions[version]}`).join(', ') : "Keine Information";
    },
    hasHDR() {
      return Object.values(this.product).some(value => value === "1");
    },
    hdrString() {
      const hdrVersions = {
        hlg: "HLG",
        hdr10: "HDR10",
        hdr10plus: "HDR10Plus",
        hdrquantum: "HDRQuantum",
        dolbyvision: "Dolby Vision",
        dolbyvisioniq: "Dolby Vision IQ"
      };
      const activeHDRVersions = Object.keys(hdrVersions).filter(key => this.product[key] === "1");
      return activeHDRVersions.length > 0 ? activeHDRVersions.map(version => hdrVersions[version]).join(", ") : "Keine Information";
    }



  },

  methods: {
    tabId(tabName) {
      return `${tabName}-${this.safeInstanceId}`;
    },
  },


  mounted() {
  },

};
</script>

<style scoped>
.datasheet-btn {
  background-color: #e6e0d980;
  border: none;
  color: rgb(98, 94, 94);
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.custom-btn:hover {
  background-color: white;
  color: black;
  border: 2px solid #4CAF50;
}

.datasheet-table th {
  background-color: #e9d9c7;
  color: #0e0808;
  text-align: left;

}

.datasheet-table td,
.datasheet-table th {
  text-align: left;
  font-size: 14px;
}

.tt-product-tabs {
  overflow-x: hidden;
  border-bottom: 1px solid #ccc;
}

.tt-product-tabs [type="radio"] {
  display: none;
}

.tt-tabs {
  display: flex;
  align-items: stretch;
  list-style: none;
  padding: 0px;
  border-bottom: 1px solid #ccc;
  margin: 0px;
}

.tt-tab>label {
  display: block;
  margin-bottom: -1px;
  border: 1px solid #ccc;
  background: #eee;
  color: #666;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  padding: 3px;
}

.tt-tab:hover label {
  border-top-color: #333;
  color: #333;
}

.tt-tab-content {
  display: none;
  color: #777;
}

.tt-product-tabs [type="radio"]:nth-of-type(1):checked~.tt-tabs .tt-tab:nth-of-type(1) label,
.tt-product-tabs [type="radio"]:nth-of-type(2):checked~.tt-tabs .tt-tab:nth-of-type(2) label,
.tt-product-tabs [type="radio"]:nth-of-type(3):checked~.tt-tabs .tt-tab:nth-of-type(3) label,
.tt-product-tabs [type="radio"]:nth-of-type(4):checked~.tt-tabs .tt-tab:nth-of-type(4) label {
  border-bottom-color: #fff;
  border-top-color: #B721FF;
  background: #fff;
  color: #222;
}

.tt-product-tabs [type="radio"]:nth-of-type(1):checked~.tt-tab-content:nth-of-type(1),
.tt-product-tabs [type="radio"]:nth-of-type(2):checked~.tt-tab-content:nth-of-type(2),
.tt-product-tabs [type="radio"]:nth-of-type(3):checked~.tt-tab-content:nth-of-type(3),
.tt-product-tabs [type="radio"]:nth-of-type(4):checked~.tt-tab-content:nth-of-type(4) {
  display: block;
}

.tt-custom-modal-body {
  padding: 0;
}

.tt-display-properties {
  margin: 5px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.tt-property {
  font-size: 15px;
}

.tt-property label {
  font-weight: bold;
  display: block;
  font-size: 14px;
}

.tt-mt-small-device {
  margin-top: 0;
}

@media (max-width: 576px) {
  .tt-mt-small-device {
    margin-top: 5px;
  }
}

.btn13 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  width: 80%;
  line-height: 1.3;
}
</style>